<script setup>
import { RouterView } from 'vue-router'
</script>

<template>
  <div id="app" class="min-h-screen bg-surface-50">
    <RouterView />
  </div>
</template>
